// Mapping inverse : leçon REMC (C1a, C2b, …) → étapes de progression (M1, O5, …)
// Utile pour convertir la sélection "lesson_codes" des fiches de séance
// en étapes de la trame 23 étapes affichable dans les fiches publiques.

import { PROGRESSION } from './progressionAutoEcole';

const _remcToEtapes = (() => {
  const map = {};
  PROGRESSION.forEach((phase) => {
    phase.steps.forEach((s) => {
      if (!s.remc) return;
      if (!map[s.remc]) map[s.remc] = [];
      map[s.remc].push(s.id);
    });
  });
  return map;
})();

export function getEtapesForLessonCode(code) {
  return _remcToEtapes[code] || [];
}

export function lessonCodesToEtapeIds(lessonCodes = []) {
  const set = new Set();
  lessonCodes.forEach((c) => {
    (_remcToEtapes[c] || []).forEach((id) => set.add(id));
  });
  return Array.from(set);
}
